import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { FibreBuilding } from '../models/fibre-building';
import { SiteAddress } from '../models/site-address';
import { FibreBuildingSite } from '../models/fibre-building-site';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FibreBuildingApiService {
  constructor(private readonly http: HttpClient) {}

  getBuildingsByCoordinates(latitude: number, longitude: number): Observable<FibreBuildingSite[]> {
    return this.http.get<FibreBuilding[]>(`${environment.fibreBuildingApiBaseUrl}/buildings/coordinates/${latitude}/${longitude}`).pipe(map((buildings: FibreBuilding[]) => {
      let index = 0;
      return buildings.map((building: FibreBuilding) => this.convertBuildingToSite(building, index++));
    }));
  }

  convertBuildingToSite(building: FibreBuilding, index: number): FibreBuildingSite {
    // Build address_line_1 from street number, street type and street name
    const address_line_1 = [building.street_number, building.street_type, building.street_name]
      .filter(v => v !== null && v !== undefined && String(v).trim() !== '')
      .join(' ');

    const sourceAddress: SiteAddress = {
      coordinates_latitude: Number(building.latitude.toFixed(8)),
      coordinates_longitude: Number(building.longitude.toFixed(8)),
      coordinates: `${building.latitude.toFixed(8)}, ${building.longitude.toFixed(8)}`,
      fibre_building_code: building.code,
      fibre_building_state: building.state,
      fibre_building_operator: building.operator.code,
      address_zip_code: building.post_code,
      address_city: building.town,
      address_city_code: building.town_insee_code,
      address_country: 'France',
      address_street_number: building.street_number,
      address_street_name: `${building.street_type} ${building.street_name}`,
      address_line_1: address_line_1
    }
    return {
      index,
      name: building.building_name,
      sourceAddress: sourceAddress
    };
  }
}
